import { render } from "./PendingPR.vue?vue&type=template&id=7db6753b"
import script from "./PendingPR.vue?vue&type=script&lang=js"
export * from "./PendingPR.vue?vue&type=script&lang=js"

import "./PendingPR.vue?vue&type=style&index=0&id=7db6753b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__